export default {
    name: 'ssn-format',
    validate(n) {
        return (
            /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/.test(n) ||
            /^(?!000|666)[0-8][0-9]{2}(?!00)[0-9]{2}(?!0000)[0-9]{4}$/.test(n)
        );
    },
};
